
import commaNumber from 'comma-number'
import analytics from '@/helpers/analytics'
import { partnerLineDisplay } from '@/helpers/currencyDisplay'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    hideSelectButton: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    pendingApproval () {
      return this.item.tier > 1
    },
    priceUi () {
      return partnerLineDisplay(this.item, this.$store.state)
    },
    minPriceFormatted () {
      return commaNumber(Math.round(this.priceUi.amount))
    },
    partnerName () {
      return this.item.provider || this.item.partnerName || this.item.name || this.item.partner
    },
    providerLogoUrl () {
      return this.item.providerLogo || null
    },
    localCurrency () {
      return this.$store.state.localCurrency
    },
    displaySymbol () {
      return this.priceUi.symbol
    }
  },
  methods: {
    openPartnerDeeplinkUrl () {
      if (this.disabled) return

      const link = this.item.partnerDeeplinkUrl || this.item.deeplink
      this.$emit('partnerClick', this.item)

      analytics.track('dropdown-pricelink-click', this)
      console.info('Open partner deeplink URL')
      window.newTab = window.open(link, '_blank')
    }
  }
}
